import { db } from '~/plugins/firebase'
import { doc, updateDoc } from 'firebase/firestore'

export const updateFirestoreDoc = async (collection, id, payload) => {
  let error
  try {
    const docRef = doc(db, collection, id)
    await updateDoc(docRef, payload)
  } catch (e) {
    error = e
  }
  return [error]
}
